/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const FolderClosedRegularV6 = (props) => (
  <Icon {...props} name="Folder Closed Regular V6">
    <path d="M14 3H8.622L7.085 1.586A1.995 1.995 0 0 0 5.672 1H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5c0-1.103-.897-2-2-2zM2 2.5h3.672c.134 0 .259.052.353.147L8 4.5h6a.5.5 0 0 1 .5.5v1h-13V3a.5.5 0 0 1 .5-.5zm12 11H2a.5.5 0 0 1-.5-.5V7.5h13V13c0 .275-.225.5-.5.5z" />
  </Icon>
);

export default FolderClosedRegularV6;
